import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

import Accordion from 'react-bootstrap/Accordion';

function IQACObjectivesBenefits() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
              <div className='row'>
                  <div className='col-md-3'>
                        <NewIqacSidebar />
                  </div>

                  <div className='col-md-9'>
                    <div class="IQACObjectivesBenefits">
                        <div className='about'>
                            <h4>About IQAC</h4>
                            <label>Committed for Inclusive, equitable and quality education
                            </label>
                            <p>To monitor standards of the higher educational institutions in India the UGC has established the NAAC (National Assessment and Accreditation Council) as an autonomous body, under Section XII (ccc) of its act in Sep’ 1994. NAAC has been instilling a momentum of quality consciousness amongst Higher Educational Institutions, aiming for continuous improvements. UGC in the XI Plan and XII plan made a policy decision that all Higher Educational Institutes (HEIs) shall establish an Internal Quality Assurance Cell (IQAC) to maintain the momentum of quality consequences. In pursuance of the National Action Plan of the National Assessment and Accreditation Council (NAAC), the Internal Quality Assurance Cell (IQAC) was constituted in MVN University with the aim of working towards realization of the goals of quality enhancement through internalization of quality culture and institutionalization of best practices. It is an integral part of the University which works towards realizing the goals of quality enhancement by developing a system for conscious, consistent and catalytic improvement in different aspects of functioning of the University.
                            </p>
                            <p>One of the prime tasks of IQAC is to develop realistic and attainable quality benchmarks for every Academic and Administrative activity. Benchmarking means fixing standards for all activities based on its own practices and the experiences of others. The IQAC acts as a mentor for Planning, Guiding, Quality Assurance (QA), and Quality Enhancement (QE) activities of the institution. Since quality enhancement is a continuous process, the IQAC becomes a part of the institution’s system and works towards the realization of goals of quality enhancement and sustenance. The university is complying with the recommended guidelines of the NAAC.
                            </p>
                            <p>This initiative fosters a culture of self-evaluation and accountability among faculty and administration, encouraging them to embrace best practices in education. Additionally, it facilitates regular feedback from stakeholders, including students and employers, ensuring that the curriculum remains relevant and aligned with industry needs.
                            </p>
                        </div>
                        <div className='row'>
                            <div className='col-md-6 col-sm-6 col-xs-12'>
                                <div className='m_box'>
                                    <div className='img'>
                                        <img src='/assets/img/ico_n-1.png'></img> 
                                    </div>
                                    <h4>University Quality Statement</h4>
                                    <p>We aim for global excellence in teaching, research, consultancy, outreach, and societal upliftment. We remain accountable in our core and support functions through self-evaluation and continuous improvement methodologies.</p>
                                </div>
                            </div>
                            <div className='col-md-6 col-sm-6 col-xs-12'>
                                <div className='m_box'>
                                    <div className='img'>
                                        <img src='/assets/img/ico_n-2.png'></img> 
                                    </div>
                                    <h4>VISION</h4>
                                    <p>To ensure quality education through institutionalizing and internalizing all the initiatives taken with internal and external support.</p>
                                </div>
                            </div>
                        </div>
                        <div className='about'>
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Objectives</Accordion.Header>
                                <Accordion.Body>
                                <ul>
                                                        <li>To develop a system for conscious, consistent and catalytic action to improve the academic and administrative performance of the institution.
                                                        </li>
                                                        <li>To promote measures for institutional functioning towards quality enhancement through internalization of quality culture and institutionalization of best practices.</li>
                                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Strategies</Accordion.Header>
                                <Accordion.Body>
                                <ul>
                                    <li>Ensuring timely, efficient and progressive performance of academic, administrative and financial tasks </li>
                                    <li>The relevance and quality of academic and research programmes</li>
                                    <li>Equitable access to and affordability of academic programmes for various sections of society</li>
                                    <li>Optimization and integration of modern methods of teaching and learning</li>
                                    <li>The credibility of evaluation procedures</li>
                                    <li>Ensuring the adequacy, maintenance and proper allocation of support structure and services</li>
                                </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Functions</Accordion.Header>
                                <Accordion.Body>
                                <ul>
                                    <li>Development and application of quality benchmarks/parameters for various academic and administrative activities of the institution;
                                    </li>
                                    <li>Facilitating the creation of a learner-centric environment conducive to quality education and faculty maturation to adopt the required knowledge and technology for participatory teaching and learning process;
                                    </li>
                                    <li>Arrangement for feedback response from students, parents and other stakeholders on quality-related institutional processes;</li>
                                    <li>Dissemination of information on various quality parameters of higher education;
                                    </li>
                                    <li>Organization of inter and intra institutional workshops, seminars on quality related themes and promotion of quality circles;
                                    </li>
                                    <li>Documentation of the various programmes/activities leading to quality improvement;
                                    </li>
                                    <li>Acting as a nodal agency of the Institution for coordinating quality-related activities, including adoption and dissemination of best practices;
                                    </li>
                                    <li>Development and maintenance of institutional database through MIS for the purpose of maintaining /enhancing the institutional quality;</li>
                                    <li>Development of Quality Culture in the institution.
                                    </li>
                                </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>Benefits</Accordion.Header>
                                <Accordion.Body>
                                <label>IQAC will facilitate / contribute -</label>
                                <ul>
                                    <li>Ensure heightened level of clarity and focus in institutional functioning towards quality enhancement;
                                    </li>
                                    <li>Ensure internalization of the quality culture;</li>
                                    <li>Ensure enhancement and coordination among various activities of the institution and institutionalize all good practices;
                                    </li>
                                    <li>Provide a sound basis for decision-making to improve institutional functioning;</li>
                                    <li>Act as a dynamic system for quality changes in MVNU.
                                    </li>
                                </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        </div>
                        <div className='about'>
                            <h4>Composition of IQAC</h4>
                            <table class="table table-bordered table-responsive composition-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Role in IQAC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Prof. (Dr.) Arun Garg</td>
                                        <td>Vice-Chancellor</td>
                                        <td>Chairman</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Prof. (Dr.) Yogendra Singh</td>
                                        <td>Registrar & Director IQAC</td>
                                        <td>Vice-Chairman</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mr. J. P. Gaur</td>
                                        <td>Member, Board of Management</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>Prof. (Dr.) N. P. Singh</td>
                                        <td>Pro Vice Chancellor & Dean</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>Dr. Kuldeep Tanwar</td>
                                        <td>Controller of Examination & Dean</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td>Dr. Rahul Varshney</td>
                                        <td>Professor & Dean</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>Dr. Ashutosh Upadhayay</td>
                                        <td>Professor & Dean</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>Dr. Vineet Kumar</td>
                                        <td>Professor & Dean</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>Mr. Daya Shankar Prasad</td>
                                        <td>Assistant Professor & Head</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td>Dr. Amit Sagu</td>
                                        <td>Assistant Professor</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>Dr. Nakul Gupta</td>
                                        <td>Associate Professor, MDI Gurugram</td>
                                        <td>Member (External)</td>
                                    </tr>
                                    <tr>
                                        <td>12</td>
                                        <td>Sourya Foundation</td>
                                        <td>NGO</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>13</td>
                                        <td>Ms. Megha (MBA, 23MS5008)</td>
                                        <td>Student Representative</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>14</td>
                                        <td>Mr. Rakesh Sharma</td>
                                        <td>Developer, Onetick Technology Pvt. Ltd.</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>15</td>
                                        <td>Mr. Sanjeev Bansal</td>
                                        <td>Assistant Registrar</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>16</td>
                                        <td>Dr. Shrivardhan Dheeman</td>
                                        <td>Deputy Director IQAC</td>
                                        <td>Member Secretary</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                  </div>


              </div>

         

      </div>

    </>
  )
}

export default IQACObjectivesBenefits